// Corey Wunderlich 2023
// www.wundervisionenvisionthefuture.com
export class PlaylistItem{
    public id:number;
    public url:string;
    constructor(id:number, url:string){
        this.id = id;
        this.url = url;
    }
}